
    <div class="info">
      <div class="my-modal__close" (click)="modalInfoRef.dismiss()">
        <i class="fa-solid fa-times"></i>
        <!-- <i class="fa-solid fa-angle-down"></i> -->
      </div>
      <div class="my-modal__body">
        <div class="mobile-design">
          <div class="mobile-design__bar">
            <div class="bar"></div>
            <div class="circle"></div>
          </div>
          <svg viewBox="0 0 127 122" fill="none" class="mobile-design__logo">
            <path d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z"></path>
            <path d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z"></path>
            <path d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z"></path>
            <path d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z"></path>
            <path d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z"></path>
          </svg>
          <div class="text">kachiing</div>
          <div class="bar-bottom"></div>
          <svg viewBox="0 0 69 68" fill="none" class="star-1">
            <path d="M34.5104 0.388L36.5764 7.59799C39.9474 19.364 49.1454 28.561 60.9114 31.932L68.1204 33.998L60.9104 36.064C49.1444 39.435 39.9474 48.632 36.5764 60.398L34.5104 67.608L32.4444 60.398C29.0734 48.632 19.8764 39.435 8.11038 36.064L0.900391 33.998L8.10939 31.932C19.8754 28.561 29.0724 19.363 32.4444 7.59799L34.5104 0.388Z" />
          </svg>
          <svg viewBox="0 0 69 68" fill="none" class="star-2">
            <path d="M34.5104 0.388L36.5764 7.59799C39.9474 19.364 49.1454 28.561 60.9114 31.932L68.1204 33.998L60.9104 36.064C49.1444 39.435 39.9474 48.632 36.5764 60.398L34.5104 67.608L32.4444 60.398C29.0734 48.632 19.8764 39.435 8.11038 36.064L0.900391 33.998L8.10939 31.932C19.8754 28.561 29.0724 19.363 32.4444 7.59799L34.5104 0.388Z" />
          </svg>
          <svg viewBox="0 0 69 68" fill="none" class="star-3">
            <path d="M34.5104 0.388L36.5764 7.59799C39.9474 19.364 49.1454 28.561 60.9114 31.932L68.1204 33.998L60.9104 36.064C49.1444 39.435 39.9474 48.632 36.5764 60.398L34.5104 67.608L32.4444 60.398C29.0734 48.632 19.8764 39.435 8.11038 36.064L0.900391 33.998L8.10939 31.932C19.8754 28.561 29.0724 19.363 32.4444 7.59799L34.5104 0.388Z" />
          </svg>
        </div>

  

        <div class="info__title">Earn up to $14 weekly when u add contributions</div>
        <div class="card-promo">
          <div class="card-promo__icon">
            <i class="fa-brands fa-product-hunt"></i>
          </div>
          <div class="card-promo__body">
            <!-- <div class="card-promo__body--meta">Product Promo Code</div> -->
            <div class="card-promo__body--title"> Up to <span>30</span> points per recommendation </div>
            <button class="t-btn" (click)="openRecommend()">Recommend Now</button>
          </div>
        </div>
        <div class="card-promo">
          <div class="card-promo__icon">
            <i class="fa-solid fa-bug"></i>
          </div>
          <div class="card-promo__body">
            <!-- <div class="card-promo__body--meta">Suggestion Promo Code</div> -->
            <div class="card-promo__body--title">Up to <span>300</span> points for suggestions and reports</div>
            <button class="t-btn" (click)="openReport()">Report Now</button>
          </div>
        </div>
        <div class="card-promo">
          <div class="card-promo__icon">
            <i class="fa-solid fa-business-time"></i>
          </div>
          <div class="card-promo__body">
            <!-- <div class="card-promo__body--meta">business Promo Code</div> -->
            <div class="card-promo__body--title">Up to <span>500</span> points for comparison articles</div>
            <button class="t-btn">Add Comparison Article Now</button>
          </div>
        </div>
        <div class="bottom-txt">
          *Bonus points (100) are given for each recommendation which are highly valued by the community
        </div>
        <button class="my-button-3" (click)="modalInfoRef.dismiss()" style="width: 100%; margin-top: 0.25rem">Start Contributing</button>
      </div>
    </div>

    <app-sign-in #SignIn></app-sign-in>